module.exports = {
	api_root: "//59.75.39.12:9875/campusapi", //XJ正式
	//api_root: "//123.139.156.12:9978/campusapi",
   	mpmanageback: '//yxxt.xijing.edu.cn:9088/mpmanageback',
   	base_url: '/xijng',
   	terminalCode: 'TM20190614112332',
   	appid: 'wxb3f0785d0cd6de69' //XJ正式
   	//appid: 'wxcb687b6d3862ace4'
}



//////////////////
// WEBPACK FOOTER
// ./server/settings.js
// module id = iBwy
// module chunks = 1